import React from "react";
import CameraAngleFilePreview from "./CameraAngleFilePreview";

/**
 * 카메라 앵글 상세정보 모달 컴포넌트
 * @param {Object} props - 컴포넌트 속성
 * @param {boolean} props.isVisible - 모달 표시 여부
 * @param {Object} props.cameraAngle - 카메라 앵글 정보
 * @param {Function} props.onClose - 모달 닫기 함수
 */
const CameraAngleDetailModal = ({
    isVisible,
    cameraAngle,
    onClose,
}) => {
    if (!isVisible || !cameraAngle) return null;

    // 앵글 타입 표시 헬퍼
    const getAngleTypeDisplay = (angle) => {
        console.log(angle);
        if (angle.isPhoto && angle.isVideo) {
            return '동영상 + 사진';
        } else if (angle.isPhoto) {
            return '사진';
        } else if (angle.isVideo) {
            return '동영상';
        } else {
            return '미설정';
        }
    };

    // 날짜 포맷팅 헬퍼
    const formatDateForDisplay = (dateString) => {
        console.log(dateString);
        if (!dateString) return '무제한';
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}${month}${day}`;
    };

    return (
        <div className="modal-overlay active" id="angle-detail-modal">
            <div className="modal-container">
                <div className="modal-header">
                    <h3 className="modal-title">카메라 앵글 상세정보</h3>
                    <button className="modal-close" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <div className="detail-item-container">
                        <span className="detail-label">카메라 앵글명</span>
                        <span className="detail-content">{cameraAngle.angleName}</span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">타입</span>
                        <span className="detail-content">{getAngleTypeDisplay(cameraAngle)}</span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">사용 기간</span>
                        <span className="detail-content">
                            {formatDateForDisplay(cameraAngle.startDatetime)} - {formatDateForDisplay(cameraAngle.endDatetime)}
                        </span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">사용 지점</span>
                        <span className="detail-content">
                            {cameraAngle.branches && cameraAngle.branches.length > 0
                                ? cameraAngle.branches.map(b => b.branchName).join(', ')
                                : '없음'}
                        </span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">배포 여부</span>
                        <span className="detail-content">
                            {cameraAngle.isDeployed ? 'Y' : 'N'}
                        </span>
                    </div>
                    
                    {/* 공통 리소스 시스템 */}
                    {cameraAngle.angleDataResourceId && (
                        <div className="detail-item-container">
                            <span className="detail-label">리소스 ID</span>
                            <span className="detail-content">{cameraAngle.angleDataResourceId}</span>
                        </div>
                    )}
                    
                    <div className="detail-item-container">
                        <span className="detail-label">작성자</span>
                        <span className="detail-content">{cameraAngle.createdBy}</span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">생성일시</span>
                        <span className="detail-content">
                            {cameraAngle.createdAt 
                                ? new Date(cameraAngle.createdAt).toLocaleString('ko-KR') 
                                : '-'}
                        </span>
                    </div>
                    
                    {cameraAngle.updatedAt && (
                        <div className="detail-item-container">
                            <span className="detail-label">수정일시</span>
                            <span className="detail-content">
                                {new Date(cameraAngle.updatedAt).toLocaleString('ko-KR')}
                            </span>
                        </div>
                    )}
                    
                    {cameraAngle.updatedBy && (
                        <div className="detail-item-container">
                            <span className="detail-label">수정자</span>
                            <span className="detail-content">{cameraAngle.updatedBy}</span>
                        </div>
                    )}
                    
                    {/* 앵글 파일 목록 */}
                    {(cameraAngle.angleFiles || cameraAngle.primaryAngleFile) && (
                        <div className="angle-files-section">
                            <h4 className="section-title">앵글 파일 정보</h4>
                            <CameraAngleFilePreview
                                files={cameraAngle.angleFiles || []}
                                primaryFile={cameraAngle.primaryAngleFile}
                            />
                        </div>
                    )}
                </div>
                <div className="modal-footer">
                    <button 
                        className="modal-btn modal-btn-primary" 
                        onClick={onClose}
                    >
                        확인
                    </button>
                </div>
            </div>
            
            <style jsx="true">{`
                .angle-files-section {
                    margin-top: 30px;
                    padding-top: 20px;
                    border-top: 1px solid #e0e0e0;
                }

                .section-title {
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 15px;
                }
            `}</style>
        </div>
    );
};

export default CameraAngleDetailModal;
